import { getAccessTokenFromLocalStorage } from '../utils/authHelpers';

const search360BaseUrl = process.env.REACT_APP_SEARCH360_HOST;

export default class BaseClient {
  async fetch(url: string, opts?: Record<string, any>) {
    opts = opts || {};

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${getAccessTokenFromLocalStorage()}`,
    };
    opts.headers = { ...headers, ...opts.headers };

    const response = await fetch(`${search360BaseUrl}${url}`, opts);

    if (!response.ok) {
      // Read the error body before throwing so callers can surface it.
      let body: unknown = undefined;
      try {
        const errText = await response.text();
        if (errText) {
          try {
            body = JSON.parse(errText);
          } catch {
            body = errText;
          }
        }
      } catch {
        // ignore body read errors
      }
      const bodyObj =
        body && typeof body === 'object'
          ? (body as Record<string, unknown>)
          : undefined;
      const message =
        typeof bodyObj?.message === 'string'
          ? (bodyObj.message as string)
          : response.statusText;
      const details = bodyObj && 'details' in bodyObj ? bodyObj.details : body;
      const responseError = {
        status: response.status,
        statusText: response.statusText,
        message,
        details,
      };
      throw responseError;
    }

    // Because fetch doesnt accept responses with empty body
    if (response) {
      const text = await response.text();
      if (text) return JSON.parse(text);
    }

    return {};
  }

  genAuthHeader(accessToken: string) {
    return {
      Authorization: `Bearer ${accessToken}`,
    };
  }
}
